var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "features pix",
      class: {
        "for-full-paywall": _vm.forFullPaywall,
        mobile: _vm.isMobile(_vm.$mq)
      }
    },
    [
      _c("h3", [_vm._v(_vm._s(_vm.headingText))]),
      _vm._v(" "),
      _c("div", { staticClass: "items" }, [
        _c("div", { staticClass: "item courses" }, [
          _c("span", { staticClass: "b-sprite-paywall-pix-lock" }),
          _vm._v(" "),
          _c("h4", [_vm._v("All courses")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n        Unlock all " +
                _vm._s(_vm.roughNumCourses) +
                " courses to build quantitative intuition and expand your\n        understanding of the world\n      "
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }